/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react';
import Fade from 'react-reveal/Fade';
import Jumbo from 'components/Components/Sections/Jumbo';
import Separator from 'components/Components/Sections/Separator';
import RectangularListElem from 'components/Components/Includes/RectangularListElem';
import SquareListElem from 'components/Components/Includes/SquareListElem';
import CallUs from 'components/Components/Sections/CallUs';
import ReadMore from 'components/Components/UI/ReadMore';
import Modal from 'components/Components/UI/Modal';
import { Link, Navigate } from 'react-router-dom';
import GetQuoteForm from 'components/Components/Forms/GetQuoteForm/Loadable';
import { find, get, isEmpty } from 'lodash';
import Spinner from 'components/Components/Includes/Spinner';
import DefaultOffer from 'components/Components/Sections/DefaultOffer';
import moment from 'moment';
import PropTypes from 'prop-types';
import {
    buildDestinationBySlugSelector,
    buildMetaDestinationSelector,
} from 'store/selectors/destinations.selector';
import { loadDestinationBySlug } from 'store/dispatchers/destinations.dispatchers';
import { connect } from 'react-redux';
import { buildMetaRegionsSelector, getRegions } from 'store/selectors/regions.selector';
import { createSelector } from 'reselect';
import { withRouteParams } from 'hoc/withRouteParams';
import { compose } from 'redux';
import { hotelUrl } from 'utils/routing-helper';
import Helmet from 'components/Helpers/Helmet';
import getFinalAttribute from 'utils/alternative-attribute';
import ModalQuote from 'components/Components/Includes/ModalQuote';
import { withLayout } from 'components/Components/Layouts/ThemeContext/with-layout';
import HeaderFormQuote from 'components/Components/Includes/HeaderFormQuote';
import DestinationPageSubMenu from './DestinationPageSubMenu';

class DestinationPage extends Component
{
    static displayName = 'DestinationPage';

    constructor(props)
    {
        super(props);
        this.state = {
            showModalQuote: false,
            headerHeight: null,
        };
        this.searchBarUpdated = false;
        this._loadDataIfNeeded = this._loadDataIfNeeded.bind(this);
        this.handleOpenModalQuote = this.handleOpenModalQuote.bind(this);
        this.handleCloseModalQuote = this.handleCloseModalQuote.bind(this);
        this.handleHeaderChangeHeight = this.handleHeaderChangeHeight.bind(this);
    }

    componentDidMount()
    {
        this.searchBarUpdated = false;
        this.updateHeader();
    }

    componentWillUnmount()
    {
        this.props.themeContext.setHeightChange(null);
    }

    componentDidUpdate()
    {
        this._loadDataIfNeeded(this.props.params.slug);
    }

    updateHeader()
    {
        this.props.themeContext.setHeightChange(this.handleHeaderChangeHeight);
        this.props.themeContext.configHeader({
            isSearch: false,
        });
    }

    _loadDataIfNeeded(slug)
    {
        if (this.currentSlug !== slug && isEmpty(this.props.destination) && !this.props.metaRegions.loading)
        {
            this.props.loadDestinationBySlug(slug);
            this.searchBarUpdated = false;
        }


        if (!isEmpty(this.props.destination) && !this.searchBarUpdated)
        {
            this.searchBarUpdated = true;
            this.props.themeContext.configHeader({
                defaultBg: 'header-transparent',
                defaultBurgerPosition: 'burger-transparent',
                searchCriteriaType: 'destination',
                showSearchBar: false,
                searchCriteria: this.props.destination.name,
                searchCriteriaId: this.props.destination.id,
                showQuoteButton: true,
                customScheduleCallButton: undefined,
            });
        }
    }

    handleOpenModalQuote()
    {
        this.setState({ showModalQuote: true });
    }

    handleCloseModalQuote()
    {
        this.setState({ showModalQuote: false });
    }

    handleHeaderChangeHeight(height)
    {
        this.setState({ headerHeight: height });
    }

    handleClickQuote(destinationHotel)
    {
        return () =>
        {
            this.setState({ destinationHotelToQuote: destinationHotel });
        };
    }

    handleCloseQuoteModal()
    {
        return () =>
        {
            this.setState({ destinationHotelToQuote: null });
        };
    }

    getHotelUrl()
    {
        if (isEmpty(this.state.destinationHotelToQuote))
        {
            return null;
        }
        return hotelUrl(this.state.destinationHotelToQuote.destination.region.slug, this.state.destinationHotelToQuote.destination.parent?.slug, this.state.destinationHotelToQuote.destination.slug, this.state.destinationHotelToQuote.hotel.slug);
    }

    render()
    {
        const {
            destination,
            metaDestination,
            metaRegions,
            pictures,
            params: { regionSlug },
        } = this.props;

        const {
            destinationHotelToQuote,
        } = this.state;

        const loading = (isEmpty(metaDestination) && isEmpty(metaRegions)) && (metaDestination.loading || metaRegions.loading);

        let amount = 0;

        if (loading)
        {
            return (
                <div className="tw-flex tw-content-center tw-flex-wrap tw-h-screen">
                    <Spinner />
                </div>
            );
        }

        if (!loading && isEmpty(destination))
        {
            return <Navigate to="/404" replace />;
        }

        return (
            <>
                <Helmet>
                    <title>{getFinalAttribute(destination, 'name')} | Luxuria Vacations</title>
                    <meta name="description" content={`${getFinalAttribute(destination, 'meta_description')}`} />
                </Helmet>

                {/* Jumbo Banner Section */}
                <Jumbo
                    image={pictures.pathJumbo}
                    title={getFinalAttribute(destination, 'name')}
                    vanish
                />

                {/* Sub Menu Section */}
                <DestinationPageSubMenu destination={destination} headerHeight={this.state.headerHeight} onOpenModalQuote={this.handleOpenModalQuote} />

                {/* Overview Section */}
                {destination.description && (
                <>
                    <section id="overview" className="tw-py-10 lg:tw-py-20 tw-px-4 tw-bg-gray-300">
                        <div className="xl:tw-container tw-text-center">
                            <Fade bottom>
                                <h2 className="font-arapey tw-text-4xl lg:tw-text-5xl tw-font-normal tw-text-gray-700 leading-12">Overview</h2>
                            </Fade>
                            <div
                                className="description-container tw-flex tw-flex-wrap lg:tw-justify-center"
                            >
                                <div className="destination tw-w-full lg:tw-w-2/3">
                                    <Fade bottom>
                                        <ReadMore
                                            textClass="tw-font-normal font-arapey tw-text-gray-700 tw-text-2xl tw-mb-4 lg:tw-mb-6 tw-mt-12"
                                            max={500}
                                        >
                                            {getFinalAttribute(destination, 'description')}
                                        </ReadMore>
                                    </Fade>
                                </div>
                            </div>
                        </div>
                    </section>
                </>
                )}

                {/* Hotels Section */}
                {destination.hotels.length > 0 && (
                <>
                    <section id="hotels" className="tw-pt-10 lg:tw-pt-20 tw-px-4">
                        <Fade bottom>
                            <h2 className="font-arapey tw-text-4xl lg:tw-text-5xl tw-font-normal tw-text-gray-700 leading-12 tw-text-center">Hotels</h2>
                        </Fade>

                        <div className="tw-flex tw-flex-wrap tw-justify-center tw-mt-16 lg:tw-mt-16">
                            {destination.hotels.map(hotel => (
                                <SquareListElem
                                    onClickQuote={this.handleClickQuote({
                                        destination,
                                        hotel,
                                    })}
                                    callToActionButton={undefined}
                                    key={hotel.id}
                                    link={hotelUrl(regionSlug, hotel.destination.destination?.slug, hotel.destination.slug, hotel.slug)}
                                    image={hotel.mainPicture || '/assets/placeholder/no-image.jpg'}
                                    title={getFinalAttribute(hotel, 'name')}
                                    subtitle={getFinalAttribute(hotel, 'destination.name')}
                                    description={getFinalAttribute(hotel, 'description')}
                                    rooms={hotel.rooms}
                                />
                            ))}
                        </div>

                    </section>
                </>
                )}

                {/* Separator */}
                {(pictures.pathSeparatorOne) && (
                    <Separator
                        image={pictures.pathSeparatorOne}
                    />
                )}

                {/* Offers Section */}
                <section id="offers" className="tw-py-10 lg:tw-py-20 tw-px-4 tw-bg-gray-300">
                    <div className="xl:tw-container tw-text-center">
                        <Fade bottom>
                            <h2 className="font-arapey tw-text-4xl lg:tw-text-5xl tw-font-normal tw-text-gray-700 leading-12">Offers</h2>
                        </Fade>
                        <div className="tw-mt-16 lg:tw-mt-16">
                            {
                                destination.hotels.length < -1 // remove false when we showing offers
                                    ? (
                                        <>
                                            {destination.hotels.map(hotel => (
                                                <React.Fragment key={hotel.id}>
                                                    {hotel.hotelValidPromotions.map((promo) =>
                                                    {
                                                        amount = promo.length + 1;
                                                        return (
                                                            <RectangularListElem
                                                                key={promo.id}
                                                                image={
                                                                    hotel.hotelPictures.find(e => e.id === promo.hotel_picture_id)
                                                                        ? hotel.hotelPictures.find(e => e.id === promo.hotel_picture_id).path
                                                                        : '/assets/placeholder/no-image.jpg'
                                                                }
                                                                title={promo.name}
                                                                titleType="promo"
                                                                goingTo={destination.name}
                                                                id={destination.id}
                                                                type="destination"
                                                                description={promo.description}
                                                                travelWin={`${promo.travel_window_from && moment(promo.travel_window_from).format('MMM D, YYYY')} - ${promo.travel_window_from && moment(promo.travel_window_from).format('MMM D, YYYY')}`}
                                                                bookingWin={`${promo.booking_window_from && moment(promo.booking_window_from).format('MMM D, YYYY')} - ${promo.booking_window_from && moment(promo.booking_window_from).format('MMM D, YYYY')}`}
                                                                blackoutDates={promo.black_out_dates_policy}
                                                                termsConditions={promo.terms_and_conditions}
                                                                headerPhoneNumber={this.props.themeContext.headerPhoneNumber}
                                                            />
                                                        );
                                                    })}
                                                </React.Fragment>
                                            ))}
                                            {
                                                amount === 0
                                                && <DefaultOffer />
                                            }
                                        </>
                                    )
                                    : <DefaultOffer />
                            }
                        </div>
                    </div>
                </section>

                {/* Separator */}
                {pictures.pathSeparatorTwo && (
                    <Separator
                        image={pictures.pathSeparatorTwo}
                    />
                )}

                {/* Call Us Section */}
                <CallUs />

                {/* Map Section */}
                {/* <GMap /> */}

                {/* Modal Quote */}
                { this.state.showModalQuote && (
                    <Modal
                        isOpen={this.state.showModalQuote}
                        modalTitle=""
                    >
                        <Link
                            className="modal-close-btn tw-text-gray-700 hover:tw-text-orange-400"
                            to="#"
                            onClick={this.handleCloseModalQuote}
                        >
                            <span className="tw-uppercase font-sp">Close</span>
                            <span className="material-icons tw-align-middle tw-ml-2">close</span>
                        </Link>
                        <HeaderFormQuote
                            logo={null}
                            url={null}
                            onClose={this.handleCloseModalQuote}
                            phoneNumber={this.props.themeContext.headerPhoneNumber}
                            altLogo={null}
                        />
                        <GetQuoteForm
                            image={pictures.pathThumb}
                            title={destination.name}
                            goingTo={destination.name}
                            subtitle={`${destination.hotels.length} Hotel${(destination.hotels.length === 1) ? '' : 's'}`}
                            description={destination.description}
                            id={destination.id}
                            type="destination"
                            onCloseModal={this.handleCloseModalQuote}
                        />
                    </Modal>
                )}

                {destinationHotelToQuote && (
                    <ModalQuote
                        image={destinationHotelToQuote.hotel.mainPicture || '/assets/placeholder/no-image.jpg'}
                        title={`${getFinalAttribute(destinationHotelToQuote.hotel, 'name')} Test DestinationPage`}
                        goingTo={destinationHotelToQuote.hotel.name}
                        id={destinationHotelToQuote.hotel.id}
                        type="hotel"
                        subtitle={getFinalAttribute(destinationHotelToQuote.destination, 'name')}
                        description={getFinalAttribute(destinationHotelToQuote.hotel, 'description')}
                        rooms={destinationHotelToQuote.hotel.hotelRooms.length > 0 ? destinationHotelToQuote.hotel.hotelRooms.length : 0}
                        onModalClose={this.handleCloseQuoteModal()}
                        headerPhoneNumber={this.props.themeContext.headerPhoneNumber}
                        logo={destinationHotelToQuote.hotel.logo}
                        logoUrl={this.getHotelUrl()}
                    />
                )}
            </>
        );
    }
}

DestinationPage.defaultProps = {
    destination: {},
    metaDestination: {},
    metaRegions: {},
};

DestinationPage.propTypes = {
    destination: PropTypes.object,
    metaDestination: PropTypes.object,
    metaRegions: PropTypes.object,
    loadDestinationBySlug: PropTypes.func.isRequired,
    params: PropTypes.object.isRequired,
    pictures: PropTypes.object.isRequired,
    themeContext: PropTypes.object,
};

const mapStateToProps = () =>
{
    const destinationSelector = createSelector(
        [buildDestinationBySlugSelector(false), getRegions],
        (destination, regions) => ({
            ...destination,
            region: { ...regions[destination.region_id] },
        }),
    );
    const metaDestinationSelector = buildMetaDestinationSelector();
    const metaRegionsSelector = buildMetaRegionsSelector();
    const picturesSelector = createSelector([destinationSelector], (destination) =>
    {
        const result = {
            pathJumbo: '',
            pathSeparatorOne: '',
            pathSeparatorTwo: '',
            pathThumb: '',
        };

        find(destination.hotels, (hotel) =>
        {
            const headerPictures = hotel.hotelPictures.filter(e => e.type === 'Header');
            const galleryPic = find(hotel.hotelPictures, { type: 'Gallery' });

            if (!result.pathJumbo)
            {
                result.pathJumbo = get(headerPictures, '0.path', '');
            }

            if (!result.pathSeparatorOne)
            {
                result.pathSeparatorOne = get(headerPictures, '1.path', '');
            }

            if (!result.pathSeparatorTwo)
            {
                result.pathSeparatorTwo = get(headerPictures, '2.path', '');
            }

            if (!result.pathThumb)
            {
                result.pathThumb = get(galleryPic, 'path', '');
            }

            return result.pathJumbo && result.pathSeparatorOne && result.pathSeparatorTwo && result.pathThumb;
        });

        return result;
    });

    return (state, props) =>
    {
        const slug = props.params ? props.params.slug : null;

        return {
            destination: destinationSelector(state, slug),
            metaDestination: metaDestinationSelector(state, slug),
            metaRegions: metaRegionsSelector(state),
            pictures: picturesSelector(state, slug),
        };
    };
};

const mapDispatchToProps = () => dispatch => ({
    loadDestinationBySlug(slug)
    {
        return dispatch(loadDestinationBySlug(slug));
    },
});

export default compose(
    withLayout,
    withRouteParams,
    connect(
        mapStateToProps,
        mapDispatchToProps,
    ),
)(withLayout(DestinationPage));
